// extracted by mini-css-extract-plugin
module.exports = {"facebookShareButton":"_3iXE5","shareButton":"_2nPQg","icon":"_2cOdT","label":"_3wS5m"};